import React from 'react'
import { Button } from 'react-bootstrap'

import { Search as SearchAPI } from '@monorepo/deprecated/hooks'
// import { Widget } from './Widget'
import { WidgetItem } from './WidgetItem'
// import { RelatedList } from './RelatedList'
import { BrandsList } from './BrandsList'

type Props = {
  brandsMeta: any[]
}

export const Sidebar: React.FC<Props> = ({ brandsMeta }) => {
  const { resetFilterHandler } = SearchAPI.useResultControl()

  return (
    <div className="block-split__item block-split__item-sidebar col-auto">
      <div className="sidebar sidebar--offcanvas--mobile">
        <div className="sidebar__backdrop" />
        <div className="sidebar__body">
          <div className="sidebar__header">
            <div className="sidebar__title">Фильтр</div>
            <button className="sidebar__close" type="button">
              <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12}>
                <path
                  d="M10.8,10.8L10.8,10.8c-0.4,0.4-1,0.4-1.4,0L6,7.4l-3.4,3.4c-0.4,0.4-1,0.4-1.4,0l0,0c-0.4-0.4-0.4-1,0-1.4L4.6,6L1.2,2.6
	c-0.4-0.4-0.4-1,0-1.4l0,0c0.4-0.4,1-0.4,1.4,0L6,4.6l3.4-3.4c0.4-0.4,1-0.4,1.4,0l0,0c0.4,0.4,0.4,1,0,1.4L7.4,6l3.4,3.4
	C11.2,9.8,11.2,10.4,10.8,10.8z"
                />
              </svg>
            </button>
          </div>
          <div className="sidebar__content">
            {/* <Widget
              title="Похожие товары"
              className="card widget-products d-none d-lg-block"
            >
              <RelatedList />
            </Widget> */}
            <div
              className="widget widget-filters widget-filters--offcanvas--mobile"
              data-collapse
              data-collapse-opened-class="filter--opened"
            >
              <div className="widget__header widget-filters__header">
                <h4>Фильтр</h4>
              </div>
              <div className="widget-filters__list">
                <WidgetItem title="Производители">
                  <BrandsList items={brandsMeta} />
                </WidgetItem>
                {/* <WidgetItem title="Цена"></WidgetItem> */}
              </div>
              <div className="widget-filters__actions d-flex">
                <Button variant="primary" size="sm" disabled>
                  Применить
                </Button>
                <Button
                  variant="secondary"
                  size="sm"
                  onClick={resetFilterHandler}
                >
                  Сбросить
                </Button>
              </div>
            </div>

            {/* <div className="card widget widget-products d-none d-lg-block">
            <div className="widget__header">
              <h4>Latest Products</h4>
            </div>
            <div className="widget-products__list">
              <div className="widget-products__item">
                <div className="widget-products__image">
                  <a href="product-full.html">
                    <img src="images/products/product-1-64x64.jpg" alt="" />
                  </a>
                </div>
                <div className="widget-products__info">
                  <div className="widget-products__name">
                    <a href="product-full.html">
                      Brandix Spark Plug Kit ASR-400
                    </a>
                  </div>
                  <div className="widget-products__prices">
                    <div className="widget-products__price widget-products__price--current">
                      $19.00
                    </div>
                  </div>
                </div>
              </div>
              <div className="widget-products__item">
                <div className="widget-products__image">
                  <a href="product-full.html">
                    <img src="images/products/product-2-64x64.jpg" alt="" />
                  </a>
                </div>
                <div className="widget-products__info">
                  <div className="widget-products__name">
                    <a href="product-full.html">
                      Brandix Brake Kit BDX-750Z370-S
                    </a>
                  </div>
                  <div className="widget-products__prices">
                    <div className="widget-products__price widget-products__price--current">
                      $224.00
                    </div>
                  </div>
                </div>
              </div>
              <div className="widget-products__item">
                <div className="widget-products__image">
                  <a href="product-full.html">
                    <img src="images/products/product-3-64x64.jpg" alt="" />
                  </a>
                </div>
                <div className="widget-products__info">
                  <div className="widget-products__name">
                    <a href="product-full.html">
                      Left Headlight Of Brandix Z54
                    </a>
                  </div>
                  <div className="widget-products__prices">
                    <div className="widget-products__price widget-products__price--new">
                      $349.00
                    </div>
                    <div className="widget-products__price widget-products__price--old">
                      $415.00
                    </div>
                  </div>
                </div>
              </div>
              <div className="widget-products__item">
                <div className="widget-products__image">
                  <a href="product-full.html">
                    <img src="images/products/product-4-64x64.jpg" alt="" />
                  </a>
                </div>
                <div className="widget-products__info">
                  <div className="widget-products__name">
                    <a href="product-full.html">
                      Glossy Gray 19" Aluminium Wheel AR-19
                    </a>
                  </div>
                  <div className="widget-products__prices">
                    <div className="widget-products__price widget-products__price--current">
                      $589.00
                    </div>
                  </div>
                </div>
              </div>
              <div className="widget-products__item">
                <div className="widget-products__image">
                  <a href="product-full.html">
                    <img src="images/products/product-5-64x64.jpg" alt="" />
                  </a>
                </div>
                <div className="widget-products__info">
                  <div className="widget-products__name">
                    <a href="product-full.html">
                      Twin Exhaust Pipe From Brandix Z54
                    </a>
                  </div>
                  <div className="widget-products__prices">
                    <div className="widget-products__price widget-products__price--current">
                      $749.00
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          </div>
        </div>
      </div>
    </div>
  )
}
